import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'
import 'semantic-ui-css/components/checkbox.css'
import 'semantic-ui-checkbox/checkbox.min'
import { buildPostJson, clearAllFilters } from '../../modules/filtering/functions.js'
import { initSearch } from '../../modules/filtering/search.js'
import { handleLozengeFilterRemoval, initDropdowns } from '../../modules/filtering/dropdowns.js'

export default class extends Controller {
  static targets = [
    'card', 'modal', 'modalResults',
    'allowAccessToAllCheckbox', 'isAccessibleToAll',
    'allowAccessRecursionCheckbox', 'isAccessRecursive',
    'profiles', 'selectedUsers', 'selectedProfileRowTemplate',
    'noProfilesContainer'
  ]

  selectedProfileIds = new Set()

  connect () {
    this.profilesTarget.querySelectorAll('[selected]').forEach(option => {
      this.selectedProfileIds.add(option.value)
    })

    if (this.hasAllowAccessToAllCheckboxTarget) {
      $(this.allowAccessToAllCheckboxTarget).checkbox()
    }
    if (this.hasAllowAccessRecursionCheckboxTarget) {
      $(this.allowAccessRecursionCheckboxTarget).checkbox()
    }

    initDropdowns(filterSetKeyPrefix)
    initSearch(
      '#user-search-input',
      () => {
        this.modalResultsTarget.style.opacity = 0.1
        $('#loadingIcon').show()
      },
      () => {
        filters.add_users_search = $('#user-search-input').val()
        $.ajax({
          type: 'POST',
          url: refreshPath,
          data: buildPostJson(filters),
          success: (response) => {
            this.modalResultsTarget.style.opacity = 1
            $('#loadingIcon').hide()
            this.modalResultsTarget.innerHTML = response.results
            this.updateSelectRemoveButtons()
          }
        })
      }
    )

    $('body').on('click', '.remove-filter-icon', (ev) => {
      handleLozengeFilterRemoval(filterSetKeyPrefix, ev)
    })

    document.addEventListener('FilterResultsUpdated', (event) => {
      this.updateSelectRemoveButtons()
    })
  }

  allowAccessToAllUsers (event) {
    this.cardTarget.classList.toggle('d-none')
    this.isAccessibleToAllTarget.checked = !this.isAccessibleToAllTarget.checked
  }

  allowAccessRecursion (event) {
    this.isAccessRecursiveTarget.checked = !this.isAccessRecursiveTarget.checked
  }

  openModal (event) {
    const modal = new Modal(this.modalTarget)
    modal.show()
  }

  selectAllUsers (event) {
    $.ajax({
      type: 'POST',
      url: getAllFilteredUsers,
      data: buildPostJson(filters),
      success: (response) => {
        for (const profile of response.results) {
          if (!this.selectedProfileIds.has(profile.id)) {
            this.selectUser(profile.id, profile.profile_picture, profile.display_name, profile.roles.map(role => role.display_name), profile.first_name, profile.last_name)
          }
        }
      }
    })
  }

  handleUserSelected (event) {
    this.selectUser(event.detail.profileId, event.detail.profilePicture, event.detail.displayName, event.detail.roles, event.detail.firstName, event.detail.lastName)
  }

  selectUser (profileId, profilePicture, displayName, roles, firstName, lastName) {
    this.profilesTarget.querySelector('option[value="' + profileId + '"]').setAttribute('selected', 'selected')

    const newSelectedProfileRow = this.selectedProfileRowTemplateTarget.cloneNode(true)
    newSelectedProfileRow.dataset.profileId = profileId
    newSelectedProfileRow.querySelector('.profile-picture-template').alt = displayName
    newSelectedProfileRow.querySelector('.profile-picture-template').src = profilePicture
    newSelectedProfileRow.querySelector('.display-name-template').textContent = displayName
    const roleBadges = []
    for (const role of roles) {
      roleBadges.push('<span class="badge badge-primary badge-raven-reg">' + role + '</span>')
    }
    newSelectedProfileRow.querySelector('.roles-template').innerHTML = roleBadges.join('')
    newSelectedProfileRow.querySelector('.first-name-template').textContent = firstName
    newSelectedProfileRow.querySelector('.last-name-template').textContent = lastName
    newSelectedProfileRow.querySelector('.remove-user-template').dataset.profileId = profileId
    this.selectedUsersTarget.appendChild(newSelectedProfileRow)
    newSelectedProfileRow.classList.remove('d-none')

    this.noProfilesContainerTarget.classList.add('d-none')

    this.selectedProfileIds.add(profileId)

    this.toggleSelectRemoveButtons(profileId)
  }

  removeUserWithCross (event) {
    this.removeUser(event.currentTarget.dataset.profileId)
  }

  removeAllUsers (event) {
    $.ajax({
      type: 'POST',
      url: getAllFilteredUsers,
      data: buildPostJson(filters),
      success: (response) => {
        for (const profile of response.results) {
          if (this.selectedProfileIds.has(profile.id)) {
            this.removeUser(profile.id)
          }
        }
      }
    })
  }

  handleUserRemoved (event) {
    this.removeUser(event.detail.profileId)
  }

  removeUser (profileId) {
    this.profilesTarget.querySelector('option[value="' + profileId + '"]').removeAttribute('selected')
    this.selectedUsersTarget.querySelector('tr[data-profile-id="' + profileId + '"]').remove()

    this.selectedProfileIds.delete(profileId)
    if (this.selectedProfileIds.size === 0) {
      this.noProfilesContainerTarget.classList.remove('d-none')
    }

    this.toggleSelectRemoveButtons(profileId)
  }

  toggleSelectRemoveButtons (profileId) {
    this.modalResultsTarget.querySelector('tr[data-profile-id="' + profileId + '"] .select-user')?.classList?.toggle('d-none')
    this.modalResultsTarget.querySelector('tr[data-profile-id="' + profileId + '"] .remove-user')?.classList?.toggle('d-none')
  }

  updateSelectRemoveButtons () {
    this.modalResultsTarget.querySelectorAll('.select-user.d-none').forEach(selectButton => {
      if (!this.selectedProfileIds.has(selectButton.dataset.profileId)) {
        this.toggleSelectRemoveButtons(selectButton.dataset.profileId)
      }
    })

    this.modalResultsTarget.querySelectorAll('.remove-user.d-none').forEach(removeButton => {
      if (this.selectedProfileIds.has(removeButton.dataset.profileId)) {
        this.toggleSelectRemoveButtons(removeButton.dataset.profileId)
      }
    })
  }

  clearAll (event) {
    filters.add_users_search = ''
    $('#user-search-input').val('')
    clearAllFilters(refreshPath, 'add_users', filters)
  }
}
